import { Check, X } from 'lucide-react';
import ScrollReveal from './ScrollReveal';

const rows = [
  { capability: 'Domain-Level Async Analysis', traditional: false, cv: true },
  { capability: 'Sitemap-Based URL Discovery + Grouping', traditional: 'Limited', cv: 'Advanced' },
  { capability: 'Master Report + Child Report Drill-Down', traditional: false, cv: true },
  { capability: 'Background Processing with Recovery', traditional: false, cv: true },
  { capability: 'JavaScript Rendering Analysis', traditional: false, cv: true },
  { capability: 'AI / LLM Visibility Check', traditional: false, cv: true },
  { capability: 'Bot Simulation', traditional: 'Limited', cv: 'Advanced' },
  { capability: 'Pre-render Support (RENDERED)', traditional: false, cv: true },
  { capability: 'Crawler Vision Score', traditional: false, cv: true },
  { capability: 'AI-Powered Recommendations', traditional: false, cv: true },
  { capability: 'Shareable Reports (HTML/PDF)', traditional: 'Limited', cv: true },
  { capability: 'Local Geo Scoring (entity & location)', traditional: false, cv: true },
  { capability: 'Generative Engine Optimization (Gen GEO)', traditional: false, cv: true },
];

const StatusCell = ({ value }) => {
  if (value === true) return <Check className="w-5 h-5 text-cv-teal mx-auto" strokeWidth={3} />;
  if (value === false) return <X className="w-5 h-5 text-cv-orange mx-auto" strokeWidth={3} />;
  return <span className="text-sm font-semibold text-cv-navy">{value}</span>;
};

const ComparisonTable = () => (
  <section className="py-20 md:py-24">
    <div className="max-w-4xl mx-auto px-4 sm:px-6">
      <ScrollReveal>
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-cv-gold/15 text-cv-navy text-xs font-bold uppercase tracking-wider rounded-full border border-cv-gold/50 mb-4">
            Comparison
          </span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-cv-navy mb-4">
            Go Beyond <span className="text-cv-navy">Traditional SEO Tools</span>
          </h2>
          <p className="text-cv-navy/70 max-w-2xl mx-auto text-lg">
            Conventional tools are page-by-page. Crawler Vision combines page diagnostics with domain-wide planning, execution, and reporting.
          </p>
        </div>
      </ScrollReveal>

      {/* Desktop table */}
      <ScrollReveal>
        <div className="hidden md:block bg-white rounded-2xl shadow-lg border border-cv-navy/10 overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="bg-cv-navy">
                <th className="text-left px-6 py-4 text-sm font-bold text-white">Capability</th>
                <th className="text-center px-6 py-4 text-sm font-bold text-white/70 w-40">Traditional Tools</th>
                <th className="text-center px-6 py-4 text-sm font-bold text-white w-40 bg-cv-teal">
                  Crawler Vision
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={row.capability} className={`border-t border-cv-navy/10 ${i % 2 === 0 ? 'bg-white' : 'bg-cv-navy/5'}`}>
                  <td className="px-6 py-4 text-sm font-medium text-cv-navy">{row.capability}</td>
                  <td className="px-6 py-4 text-center">
                    <StatusCell value={row.traditional} />
                  </td>
                  <td className="px-6 py-4 text-center bg-cv-sky/20">
                    <StatusCell value={row.cv} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </ScrollReveal>

      {/* Mobile stacked cards */}
      <div className="md:hidden space-y-3">
        {rows.map((row, i) => (
          <ScrollReveal key={row.capability} delay={i * 0.05}>
            <div className="bg-white rounded-xl border border-cv-navy/10 p-4 shadow-sm">
              <p className="text-sm font-bold text-cv-navy mb-3">{row.capability}</p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2 text-cv-navy/60">
                  <StatusCell value={row.traditional} />
                  <span className="text-xs">Traditional</span>
                </div>
                <div className="flex items-center gap-2 text-cv-navy">
                  <StatusCell value={row.cv} />
                  <span className="text-xs font-semibold">Crawler Vision</span>
                </div>
              </div>
            </div>
          </ScrollReveal>
        ))}
      </div>
    </div>
  </section>
);

export default ComparisonTable;
